import { ResponseWrapper, PagedResults, UserDto, trackerGet, decodeResult } from "./basicApi.ts";


// Get details of the given user, including group membership
async function getUserDetails(userId: string): Promise<ResponseWrapper<UserDto>> {
  const result = await trackerGet(`users/${userId}/`, {});
  return decodeResult(result);
}


// Get a list of Users known to the system
async function getUsers(): Promise<ResponseWrapper<PagedResults<UserDto>>> {
  const result = await trackerGet(`users/`, {});
  return decodeResult(result);
}


export { getUserDetails, getUsers }
